import { render, staticRenderFns } from "./SupportTicketNewReply.vue?vue&type=template&id=02ddd440&scoped=true&"
import script from "./SupportTicketNewReply.vue?vue&type=script&lang=js&"
export * from "./SupportTicketNewReply.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketNewReply.vue?vue&type=style&index=0&id=02ddd440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddd440",
  null
  
)

export default component.exports